//
import { createSelector } from '@reduxjs/toolkit';

import { institutionLoginsSelectors } from 'app-components/flux/institution-logins';

import { APP_REDUCER_KEY } from './reducer';

export const getAppStore = (state) => state[APP_REDUCER_KEY];

export const getIsOffline = (state) => getAppStore(state).isOffline;

export const getServiceWorkerIsRegistered = (state) => getAppStore(state).serviceWorkerIsRegistered;
export const getServiceWorkerIsRegistering = (state) => getAppStore(state).serviceWorkerIsRegistering;
export const getServiceWorkerUpdateIsAvailable = (state) => getAppStore(state).serviceWorkerUpdateIsAvailable;

export const getAwaitingToAutoRefresh = (state) => getAppStore(state).awaitingToAutoRefresh;

export const getUpdateAllFailed = (state) => getAppStore(state).updateAllFailed;
export const getUpdateAllMessages = (state) => getAppStore(state).updateAllMessages;
export const getDBUpdateTrigger = (state) => getAppStore(state).dbUpdateTrigger;
export const getFetchInProgress = (state) => getAppStore(state).fetchInProgress;
export const getSessionStartedAt = (state) => getAppStore(state).sessionStartedAt;

export const disableRefreshButton = createSelector(
  getAwaitingToAutoRefresh,
  institutionLoginsSelectors.getIsRefreshingSome,
  getFetchInProgress,
  (awaitingToAutoRefresh, someLoginsAreRefreshing, fetchInProgress) =>
    awaitingToAutoRefresh || someLoginsAreRefreshing || fetchInProgress,
);

// todo: add other loading/refreshing conditions?
export const isRefreshing = createSelector(
  institutionLoginsSelectors.getIsRefreshingAll,
  getFetchInProgress,
  (allLoginsAreRefreshing, fetchInProgress) => allLoginsAreRefreshing || fetchInProgress,
);

// makeSelectLocationState expects a plain JS object for the routing state
const makeSelectLocationState = () => {
  let prevRoutingState;
  let prevRoutingStateJS;

  return (state) => {
    const routingState = state.get('route'); // or state.route

    if (!routingState.equals(prevRoutingState)) {
      prevRoutingState = routingState;
      prevRoutingStateJS = routingState.toJS();
    }

    return prevRoutingStateJS;
  };
};

export const isSanitized = (state) => getAppStore(state).isSanitized;

export const csvImportCompleteByClientId = (state) => getAppStore(state).csvImportCompleteByClientId;
export const csvImportCompleteForClientId = (state, clientId) =>
  (csvImportCompleteByClientId(state) || {}).get(clientId);

export const csvImportErrorByClientId = (state) => getAppStore(state).csvImportErrorByClientId;
export const csvImportErrorForClientId = (state, clientId) => (csvImportErrorByClientId(state) || {}).get(clientId);

export const csvImportFilesInProgress = createSelector(
  csvImportErrorByClientId,
  csvImportCompleteByClientId,
  (state, csvImportFilesByClientId) => csvImportFilesByClientId,
  (csvImportError, csvImportComplete, csvImportFiles) =>
    csvImportFiles.filter(
      (_csvImportFile, clientId) => !csvImportComplete.get(clientId) && !csvImportError.get(clientId),
    ),
);

export const csvImportFilesSucceed = createSelector(
  csvImportCompleteByClientId,
  (state, csvImportFilesByClientId) => csvImportFilesByClientId,
  (csvImportComplete, csvImportFiles) =>
    csvImportComplete.filter((_csvImportFile, clientId) => csvImportFiles.get(clientId)),
);

export const csvImportFilesFailed = createSelector(
  csvImportErrorByClientId,
  csvImportCompleteByClientId,
  (state, csvImportFilesByClientId) => csvImportFilesByClientId,
  (csvImportErrors, csvImportComplete, csvImportFiles) =>
    csvImportErrors.filter(
      (_csvImportFile, clientId) => csvImportFiles.get(clientId) && !csvImportComplete.get(clientId),
    ),
);

export { makeSelectLocationState };
